<template>
  <div class="home-news-body">
    <div>
      <div class="home-news-content">
        <div class="home-news-carousel-box">
          <a-carousel autoplay dots-class="home-news-dots">
            <div
              class="home-news-carousel-list"
              v-for="item in carouselList"
              :key="item.id"
            >
              <v-img
                :attachment-id="item.attachment.attachmentId"
                :default-img="require('@/assets/img/mediaPic1.jpg')"
                @click="handleBannerClick(item)"
              ></v-img>
              <p>{{ item.adName }}</p>
            </div>
            <!-- <div class="home-news-carousel-list">
              <img src="@/assets/img/mediaPic2.jpg" />
              <p>供场景给机会 加快新经济发展的若干政策措施</p>
            </div>
            <div class="home-news-carousel-list">
              <img src="@/assets/img/mediaPic3.jpg" />
              <p>供场景给机会 加快新经济发展的若干政策措施</p>
            </div> -->
          </a-carousel>
        </div>
        <div class="home-news-list-box">
          <div class="home-news-list-title">
            <p>新闻动态</p>
            <span @click="$router.push(`/homeDynamic`)">查看更多></span>
          </div>
          <div class="home-news-list">
            <div v-for="(el, index) in news" :key="index">
              <p @click="$router.push(`/homeDynamic/detail?id=${el.id}`)">
                <i></i>
                <span>{{ el.newsName }}</span>
              </p>
              <span>{{ el.publishTime | moment("YYYY-MM-DD") }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="home-news-footer-body">
        <div @click="$router.push(`/homeScenes`)">
          <div>
            <p>场景清单</p>
            <span>Scene List</span>
          </div>
        </div>
        <div @click="$router.push(`/homeResults`)">
          <div>
            <p>场景成果</p>
            <span>Scene Results</span>
          </div>
        </div>
        <div @click="$router.push(`/homeKnowledge`)">
          <div>
            <p>场景要素知识云</p>
            <span>Scene Element Knowledge Cloud</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsList, getPublicityAdBanner } from "@/api/news";
import VImg from "@/components/VImg";
export default {
  components: { VImg },
  data() {
    return {
      news: [],
      carouselList: [],
    };
  },
  methods: {
    loadData() {
      getNewsList({ current: 1, size: 5 }, {}).then((res) => {
        this.news = res.data.records;
      });
    },
    loadgetPublicityAdBanner() {
      getPublicityAdBanner().then((res) => {
        this.carouselList = res.data;
      });
    },
    handleBannerClick(el) {
      if (el.link) {
        window.open(`${el.link}`);
      }
    },
  },
  mounted() {
    this.loadData();
    this.loadgetPublicityAdBanner();
  },
};
</script>

<style lang="less" scoped>
.home-news-body {
  background: #fff;
  padding: 56px 0 40px;
  > div {
    width: 1200px;
    margin: 0 auto;
    .home-news-content {
      display: flex;
      justify-content: space-between;
      > div {
        width: 588px;
      }
      .home-news-carousel-box {
        height: 336px;
        .home-news-carousel-list {
          position: relative;
          height: 336px;
          > img {
            display: block;
            width: 100%;
            height: 100%;
          }
          > p {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 2;
            height: 40px;
            background: rgba(000, 000, 000, 0.64);
            color: #fff;
            line-height: 40px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            padding: 0 16px;
          }
        }
      }
      .home-news-list-box {
        .home-news-list-title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 20px;
          > p {
            font-size: 20px;
            line-height: 20px;
            padding-left: 12px;
            border-left: 4px solid #0d6fb8;
          }
          > span {
            line-height: 14px;
            color: #8c8c8c;
          }
        }
        .home-news-list {
          > div {
            display: flex;
            padding: 16px 0;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid #f0f0f0;
            cursor: pointer;
            > p {
              display: flex;
              align-items: center;
              width: 70%;
              > i {
                width: 6px;
                height: 6px;
                background: #0d6fb8;
                margin-right: 16px;
              }
              > span {
                max-width: 420px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
            > span {
              font-size: 16px;
              color: #8c8c8c;
            }
          }
        }
      }
    }
    .home-news-footer-body {
      display: flex;
      margin-top: 56px;
      justify-content: space-between;
      > div {
        width: 384px;
        height: 120px;
        display: flex;
        align-items: center;
        padding-left: 110px;
        background-size: 100% 100%;
        cursor: pointer;
        &:nth-child(1) {
          background: url(../../../assets/img/homeicon1.jpg) no-repeat;
        }
        &:nth-child(2) {
          background: url(../../../assets/img/homeicon2.jpg) no-repeat;
        }
        &:nth-child(3) {
          background: url(../../../assets/img/homeicon3.jpg) no-repeat;
        }
        > div {
          > p {
            font-size: 24px;
            line-height: 24px;
            text-shadow: 3px 3px 0px rgba(0, 0, 0, 0.16);
            margin-bottom: 16px;
            color: #fff;
            font-weight: bold;
          }
          > span {
            display: block;
            line-height: 14px;
            color: #fff;
            opacity: 0.4;
          }
        }
      }
    }
  }
}
</style>
<style>
.home-news-dots {
  width: auto !important;
  right: 16px !important;
  bottom: 22px !important;
}
</style>
